const colorFor = (score) =>
  score >= 75 ? "#22C55E" : score >= 50 ? "#FACC15" : "#EF4444";

export const ScoreGauge = ({ score = 0, size = 220, stroke = 16, label }) => {
  const isNa = score === null || score === undefined;
  const val = isNa ? 0 : Math.max(0, Math.min(100, score));
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (val / 100) * circumference;
  const color = isNa ? "#71717A" : colorFor(val);

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: "rotate(-90deg)" }}>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#3F3F46" strokeWidth={stroke} />
        {!isNa && (
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={stroke}
            strokeLinecap="butt"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
          />
        )}
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-display leading-none text-white" style={{ fontSize: size * (isNa ? 0.5 : 0.34) }} data-testid="overall-score-value">
          {isNa ? "\u2014" : score}
        </span>
        {!isNa && <span className="font-heading text-xs uppercase tracking-widest text-zinc-500 mt-1">/ 100</span>}
        {label && (
          <span className="font-heading text-sm uppercase tracking-wider mt-2" style={{ color }}>
            {label}
          </span>
        )}
      </div>
    </div>
  );
};

export default ScoreGauge;
